module.exports = __webpack_public_path__ + "img/netapp.5c1866dd.png";